import type { Metric, Counter, Histogram } from "./types";
import { buildCounter, buildHistogram } from "./builders";
import { renderMany } from "./render";

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-empty-function, @typescript-eslint/explicit-module-boundary-types
export const NOOP = () => { };

export interface Metrics {
  getCounter: (name: string) => Counter;
  getHistogram: (name: string, buckets: number[]) => Histogram;
}

export function buildMetrics(baseName: string, gatewayUrl: string, reportError: (error: Error) => void = NOOP): Metrics {
  const requestQueue: Promise<unknown>[] = [];

  const flush = async (): Promise<void> => {
    await Promise.all(requestQueue);
    requestQueue.length = 0;
  }

  const renderAndPush = (metrics: Metric | Metric[]): void => {
    const metricsArray = Array.isArray(metrics) ? metrics : [metrics];
    const body = renderMany(metricsArray);

    const request: Promise<unknown> = fetch(`${gatewayUrl}`, {
      method: "POST",
      headers: { "Content-Type": "text/plain; charset=utf-8" },
      body
    }).catch(error => reportError(error)).finally(flush);

    requestQueue.push(request);
  };


  return {
    getCounter: (name: string): Counter => {
      const sanitizedName = `${baseName}_${name}_total`;

      return buildCounter(sanitizedName, renderAndPush);
    },
    getHistogram: (name: string, buckets: number[]): Histogram => {
      const sanitizedName = `${baseName}_${name}`;

      return buildHistogram(sanitizedName, buckets, renderAndPush);
    }
  };
}

